import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const deleteNominationReviewer: (
  fetchContext: FetchContext,
  nominationId: number,
  nominationReviewerId: number,
  accessToken?: string,
) => Promise<void> = async (fetchContext, nominationId, nominationReviewerId, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/admin/nominations/${nominationId}/reviewers/${nominationReviewerId}`,
  {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'delete nomination reviewer'));
